import { createFileRoute } from "@tanstack/react-router";

import { faqSchema } from "@/components/FaqSection";
import { ServiceLinePage } from "@/components/ServiceLinePage";
import { faqsFor } from "@/lib/faqs";
import { breadcrumbSchema, canonical, pageMeta } from "@/lib/seo";
import { serviceLineContent } from "@/lib/segments-content";

const content = serviceLineContent["operacoes-complexas"]!;
const faqs = faqsFor(content.path);

export const Route = createFileRoute("/servicos/operacoes-complexas")({
  head: () => ({
    meta: pageMeta({
      title: content.seoTitle,
      description: content.seoDescription,
      path: content.path,
    }),
    links: canonical(content.path),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbSchema([
            { name: "Serviços", path: "/servicos" },
            { name: content.title, path: content.path },
          ]),
        ),
      },
      ...(faqs.length > 0
        ? [{ type: "application/ld+json", children: JSON.stringify(faqSchema(faqs)) }]
        : []),
    ],
  }),
  component: () => <ServiceLinePage content={content} />,
});
